<template>
  <Loading v-show="true" />
</template>

<script>
import Loading from '@/components/Loading';

export default {
  name: 'AuthenticatingView',
  components: {
    Loading,
  },
  mounted() {
    this.$router.push('/');
  },
};
</script>
